import {DataFetcher} from '@aboutyou/data-fetcher';
import {DeferredElement} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/deferred_element.types';
import React from 'react';
import {HeroContentProductsProps} from './HeroContentSwitch';
import {HeroContentView} from './HeroContentView';
import {useGetDeferredProducts} from './utils/useGetDeferredProducts';

export const HeroContentDeferred: React.FC<
  HeroContentProductsProps & {
    deferred: DeferredElement;
  }
> = ({deferred, discoverMore, ...rest}) => {
  return (
    <DataFetcher
      request={useGetDeferredProducts(deferred)}
      Loading={() => null}
      Error={null}
      View={HeroContentView}
      viewProps={{
        discoverMore,
        ...rest,
      }}
    />
  );
};
